"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.Heading = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../../assets/styles/colors");
const media_1 = require("../../../../../utils/media");
const Typography_1 = require("../../../../atoms/Typography");
const Label = (0, styled_components_1.default)(Typography_1.H5) `
  padding-bottom: 10px;
  font-weight: 500;
  text-transform: uppercase;

  @media ${media_1.media.desktop} {
    color: ${colors_1.gray300};
    font-size: 14px;
    font-weight: 400;
  }
`;
exports.Label = Label;
const Heading = (0, styled_components_1.default)(Typography_1.H1) `
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media ${media_1.media.desktop} {
    font-size: 28px;
  }
`;
exports.Heading = Heading;
